import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/inventory/po/$id/update')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_app/inventory/po/$id/update"!</div>
}
